<template>
    <div class="stop_info">
        <div  class="bd-callout bd-callout-info">

                <b-tabs>
                    <b-tab :key="market.id" v-for="market in markets">
                        <template #title>
                            <div class="provider">
                                <div class="icon" style="max-width: 25px" v-html="market.icon"></div>
                                {{market.name}}
                            </div>
                        </template>

                        <p class="pt-2">
                            <b-overlay :show="is_load">

                                <b-table v-if="filter_by_market(market,rows).length > 0"
                                         striped class="table-responsive-xl resolution_table"
                                         :items="filter_by_market(market,rows)"
                                         :fields="fields"
                                >

                                    <template v-slot:head(filename)="data">
                                        <div class="status_info" style="max-width: 50px">
                                            {{__t('O_EXP_IC')}}
                                        </div>
                                    </template>

                                    <!-- body -->
                                    <template  v-slot:cell(filename)="data">
                                        <div class="img_block  rounded" style="max-width: 75px">
                                            <picture v-if="obj_to_null(data.item.image)">
                                                <source :srcset="data.item.image.webp" type="image/webp">
                                                <source :srcset="data.item.image.jpeg" type="image/jpeg">
                                                <img style="max-width: 75px"  itemprop="image" :src="data.item.image.jpeg">
                                            </picture>
                                        </div>
                                    </template>

                                    <template v-slot:cell(title)="data">
                                        <div class="">
                                            <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                                <div  class="icon-stack fs-xxl mr-2 ">
                                                    <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                                    <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                                </div>
                                                <span v-if="obj_to_null(data.item.product)">
                                                    {{data.item.product.title}}
                                                </span>

                                                <span v-else>
                                                    NOT_FOUND
                                                </span>
                                            </div>

                                            <div class="d-flex flex-start w-100">
                                                <div class="small badge border border-info" v-if="obj_to_null(data.item)">
                                                    <span v-if="data.item.is_prod">{{__t('CATEG:')}}</span>
                                                    <span v-else>{{__t('GROUP:')}}</span>
                                                    {{data.item.main_category.title }}
                                                </div>

                                                <div class="small badge border border-info ml-3" v-if="obj_to_null(data.item)">
                                                    {{data.item.product_uniq }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(rest_id)="data" >
                                        <div class="prod_name  fs-xl color-success-600" v-if="data.item.hasOwnProperty('restaurant')">
                                            <span >
                                                 {{data.item.restaurant.title}}
                                            </span>
                                            <div class="small text-info">
                                                <div class="small badge border border-warning">
                                                    {{data.item.restaurant.uniq_id}}
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(location)="data" >
                                        <div class="prod_name  fs-xl" v-if="data.item.hasOwnProperty('location')">
                                            <span>
                                                 {{data.item.location.title}}
                                            </span>
                                            <div class="small text-info">
                                                <div class="small badge border border-warning">
                                                    {{data.item.location.uniq_id}}
                                                </div>
                                            </div>
                                        </div>

                                    </template>

                                    <template v-slot:cell(added)="data" >
                                        {{data.item.added}}
                                    </template>

                                    <template v-slot:cell(client_id)="data">
                                        <span class="fs-xl cursor-pointer" v-on:click="remove_stop(data.item)">
                                            <i class="fas fa-trash"></i>
                                        </span>
                                    </template>
                                </b-table>
                            </b-overlay>
                        </p>
                    </b-tab>
                </b-tabs>
        </div>
    </div>
</template>


<script>

export default {
    name: "StopItemInfo",
    components: { },
    props: {
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            is_load : true,
            rows : [],
            fields: [
             //   { key: 'provider', label: '', class: 'text-left m_width_50' },
                { key: 'filename', label: ' - ', class: 'text-center' },
                { key: 'title', label: 'p.title', class: '' },
                { key: 'rest_id', label: 'b.rest_id', class: '' },
                { key: 'location', label: 'loc_id', class: '' },
                { key: 'added', label: 'added', class: '' },
                { key: 'client_id', label: '', class: '' }
            ],
        }
    },

    created() {
        this.load_item();
    },

    methods : {

        filter_by_market(market,rows) {
            return rows.filter(row => {
                let row_market = row.aggregator;
                return parseInt(row_market.id) === parseInt(market.id);
            });
        },

        async remove_stop(black_record) {
            this.$emit('remove_stop',black_record);
        },

        async load_item() {
            this.rows = [];
            this.is_load = true;
            await api.get('/internal/v1/catalog/stop_list/' + this.item.product.uniq_id).then(({ data }) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.rows = data.data;
                }

            }).catch(({ response }) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },
    },

    computed : {
        markets() {
            if(this.item.hasOwnProperty("aggregators")) {
                return this.item.aggregators;
            }

            return [];
        }
    },
}
</script>


<style scoped>
.provider .icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    margin-right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
}

.provider .icon img,
.provider .icon svg {
    max-width: 100%;
    max-height: 100%;
    border-radius: 6px;
}
</style>
